var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1728698102823,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1573,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M469.333333 85.333333m42.666667 0l0 0q42.666667 0 42.666667 42.666667l0 128q0 42.666667-42.666667 42.666667l0 0q-42.666667 0-42.666667-42.666667l0-128q0-42.666667 42.666667-42.666667Z",
    fill: "#FFFFFF",
    opacity: 0.8,
    "p-id": 1574
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M469.333333 725.333333m42.666667 0l0 0q42.666667 0 42.666667 42.666667l0 128q0 42.666667-42.666667 42.666667l0 0q-42.666667 0-42.666667-42.666667l0-128q0-42.666667 42.666667-42.666667Z",
    fill: "#FFFFFF",
    opacity: 0.4,
    "p-id": 1575
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M938.666667 469.333333m0 42.666667l0 0q0 42.666667-42.666667 42.666667l-128 0q-42.666667 0-42.666667-42.666667l0 0q0-42.666667 42.666667-42.666667l128 0q42.666667 0 42.666667 42.666667Z",
    fill: "#FFFFFF",
    opacity: 0.2,
    "p-id": 1576
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M298.666667 469.333333m0 42.666667l0 0q0 42.666667-42.666667 42.666667l-128 0q-42.666667 0-42.666667-42.666667l0 0q0-42.666667 42.666667-42.666667l128 0q42.666667 0 42.666667 42.666667Z",
    fill: "#FFFFFF",
    opacity: 0.6,
    "p-id": 1577
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M783.530667 180.138667m30.169889 30.169889l0 0q30.169889 30.169889 0 60.339779l-90.509668 90.509668q-30.169889 30.169889-60.339779 0l0 0q-30.169889-30.169889 0-60.339779l90.509668-90.509668q30.169889-30.169889 60.339779 0Z",
    fill: "#FFFFFF",
    opacity: 0.1,
    "p-id": 1578
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M330.965333 632.661333m30.16989 30.16989l0 0q30.169889 30.169889 0 60.339778l-90.509668 90.509668q-30.169889 30.169889-60.339779 0l0 0q-30.169889-30.169889 0-60.339778l90.509668-90.509668q30.169889-30.169889 60.339779 0Z",
    fill: "#FFFFFF",
    opacity: 0.5,
    "p-id": 1579
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M843.861333 783.530667m-30.169889 30.169889l0 0q-30.169889 30.169889-60.339779 0l-90.509668-90.509668q-30.169889-30.169889 0-60.339779l0 0q30.169889-30.169889 60.339779 0l90.509668 90.509668q30.169889 30.169889 0 60.339779Z",
    fill: "#FFFFFF",
    opacity: 0.3,
    "p-id": 1580
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M391.338667 330.965333m-30.16989 30.16989l0 0q-30.169889 30.169889-60.339778 0l-90.509668-90.509668q-30.169889-30.169889 0-60.339779l0 0q30.169889-30.169889 60.339778 0l90.509668 90.509668q30.169889 30.169889 0 60.339779Z",
    fill: "#FFFFFF",
    opacity: 0.7,
    "p-id": 1581
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.ddf3827589e4c413150588246ba89b85.svg";
export { ForwardRef as ReactComponent };